import { defaultClientRoleId } from "@smart/bridge-smokeball-basic";

import { findClientRoles } from "../../../shared/validation-utils";
import type { GqlFieldValues, GqlMatterType } from "../types";

const webEnquiryRelatedFieldNames = new Set([
  "person/firstName",
  "person/lastName",
  "company/name",
]);

const isWebEnquiryRelatedField = (
  field: GqlFieldValues["field"] | null | undefined,
): boolean => {
  const name = field?.name;
  if (!name) return false;
  return webEnquiryRelatedFieldNames.has(name);
};

export const isWebEnquiryClientNameField = (
  field: GqlFieldValues,
  matterTypes?: GqlMatterType[] | null,
): boolean => {
  if (!isWebEnquiryRelatedField(field.field)) return false;
  const layoutId = field.layout?.id;
  if (!layoutId) return false;
  const clientRoles = findClientRoles(matterTypes || []);
  return [defaultClientRoleId, ...clientRoles].includes(layoutId);
};
